(function () {
  "use strict";

  var MAX_GSAP_WAIT = 60;

  function waitForGsap(callback) {
    if (typeof window.zeusWhenGsapReady === "function") {
      window.zeusWhenGsapReady(callback);
      return;
    }
    var waitTicks = 0;
    function poll() {
      if (window.gsap && window.ScrollTrigger) {
        callback();
        return;
      }
      waitTicks += 1;
      if (waitTicks < MAX_GSAP_WAIT) {
        window.requestAnimationFrame(poll);
      }
    }
    poll();
  }

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function statSnapStep(target) {
    if (target >= 10000) return 500;
    if (target >= 1000) return 50;
    if (target >= 100) return 10;
    return 5;
  }

  function initStatCounter(root) {
    if (root.getAttribute("data-stat-counter") !== "true") return;
    if (prefersReducedMotion()) return;

    var counter = root.querySelector("[data-zeus-stat-counter]");
    if (!counter || counter.dataset.zeusStatCounterInit === "true") return;

    var valueEl = counter.querySelector("[data-zeus-stat-value]");
    if (!valueEl) return;

    // Fix 2: parse digits only to handle formatted values like "30k", "30 000".
    // Only animate when the raw attribute value is purely numeric (no letters, no spaces).
    var rawAttr = (counter.getAttribute("data-stat-value") || "").trim();
    var digitsOnly = rawAttr.replace(/[^0-9]/g, "");
    var isPureNumeric = /^[0-9]+$/.test(rawAttr);
    var target = parseInt(digitsOnly, 10);
    if (!target || target <= 0) return;

    // Fix 3: the original formatted text to restore on animation complete.
    var originalText = valueEl.textContent;

    // Fix 3: set a stable accessible name on the heading so SR reads the final value,
    // not the animated "0" during count-up. Walk up to the nearest heading ancestor.
    var headingEl = counter.closest("h1,h2,h3,h4,h5,h6");
    if (headingEl && !headingEl.getAttribute("aria-label")) {
      // Build the full accessible label: stat + optional "+" + caption text.
      var plusEl0 = counter.querySelector("[data-zeus-stat-plus]");
      var captionEl = headingEl.querySelector(".zeus-partners-strip__stat-caption");
      var aLabel = rawAttr + (plusEl0 ? "+" : "");
      if (captionEl) aLabel += " " + captionEl.textContent.trim();
      headingEl.setAttribute("aria-label", aLabel.trim());
    }

    var plusEl = counter.querySelector("[data-zeus-stat-plus]");

    function bind() {
      var gsap = window.gsap;
      var ScrollTrigger = window.ScrollTrigger;
      if (!gsap || !ScrollTrigger) return false;

      gsap.registerPlugin(ScrollTrigger);
      counter.dataset.zeusStatCounterInit = "true";
      root.classList.add("is-stat-counter");

      var locale =
        (document.documentElement.lang || "fr").replace("_", "-").split("-")[0] === "fr"
          ? "fr-FR"
          : document.documentElement.lang || undefined;
      var snapStep = statSnapStep(target);
      var state = { v: 0 };

      ScrollTrigger.create({
        trigger: counter,
        start: "top 85%",
        once: true,
        onEnter: function () {
          if (!isPureNumeric) {
            // Non-numeric stat (e.g. "30k"): skip count-up, leave text as-is.
            if (plusEl) {
              gsap.to(plusEl, { opacity: 1, scale: 1, duration: 0.45, ease: "back.out(2)" });
            }
            return;
          }
          if (plusEl) {
            gsap.set(plusEl, { opacity: 0, scale: 0.6, transformOrigin: "left center" });
          }
          state.v = 0;
          valueEl.textContent = "0";

          gsap.to(state, {
            v: target,
            duration: 1.8,
            ease: "power2.out",
            snap: { v: snapStep },
            onUpdate: function () {
              valueEl.textContent = Math.round(state.v).toLocaleString(locale);
            },
            onComplete: function () {
              // Fix 2: restore the original formatted string, never clobber with raw integer.
              valueEl.textContent = originalText;
              if (plusEl) {
                gsap.to(plusEl, {
                  opacity: 1,
                  scale: 1,
                  duration: 0.45,
                  ease: "back.out(2)",
                });
              }
            },
          });
        },
      });

      if (typeof window.zeusScrollTriggerRefresh === "function") {
        window.zeusScrollTriggerRefresh();
      } else {
        ScrollTrigger.refresh();
      }
      return true;
    }

    waitForGsap(bind);
  }

  function init(root) {
    if (!root || root.dataset.zeusPartnersInit === "true") return;
    root.dataset.zeusPartnersInit = "true";

    initStatCounter(root);

    var marquee = root.querySelector("[data-zeus-partners-marquee]");
    var pauseBtn = root.querySelector("[data-zeus-partners-marquee-pause]");
    var reduced = prefersReducedMotion();

    if (reduced && marquee) {
      marquee.classList.add("is-static");
    }

    if (!pauseBtn || !marquee || marquee.classList.contains("is-static")) return;

    pauseBtn.addEventListener("click", function () {
      var paused = marquee.classList.toggle("is-paused");
      pauseBtn.setAttribute("aria-pressed", paused ? "true" : "false");
      var label = paused ? pauseBtn.getAttribute("data-label-resume") : pauseBtn.getAttribute("data-label-pause");
      if (label) pauseBtn.setAttribute("aria-label", label);
      var labelEl = pauseBtn.querySelector(".zeus-partners-strip__pause-label");
      if (labelEl && label) labelEl.textContent = label;
      var iconPause = pauseBtn.querySelector(".zeus-partners-strip__marquee-pause-icon--pause");
      var iconPlay = pauseBtn.querySelector(".zeus-partners-strip__marquee-pause-icon--play");
      if (iconPause) iconPause.classList.toggle("hidden", paused);
      if (iconPlay) iconPlay.classList.toggle("hidden", !paused);
    });
  }

  function boot() {
    document.querySelectorAll("[data-zeus-partners-strip]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-zeus-partners-strip]");
    if (root) {
      root.dataset.zeusPartnersInit = "false";
      init(root);
    }
  });
})();
